<template>
    <div class="list" >
        <div v-for="(item,index) of itemlist" :key="index"  >
            <router-link :to="'/list?id='+item.id">
              <img class="ziyuan" src="../../assets/ziyuan.png" alt="">
            </router-link>
            <div class="itemText">
              {{item.name}}
            </div>
        </div>
    </div>
</template>

<script>

export default {
  props:["itemlist"],
  data () {
    return {
       
    }
  },
  methods:{
    toList(id){
      this.$router.push({name: 'list', params: {id: id}});
    }
  }
}
</script>
<style scoped>
 
  .list{
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      font-size:13px;
      color:#565656;
      border-top:1px solid #f3f3f3;
      padding-top:29px;
  }
  .list>div{
      width:25%;
    margin-bottom:29px;
  }
  .itemText{
    margin:auto;
    text-align: center;
    width:95%;
  }
  .ziyuan{
    width:30%;
    margin-bottom:13px
  }
</style>



// WEBPACK FOOTER //
// src/components/common/itemlist.vue